const getDefaultState = () => {
  return {
    casts: [],
    castsInfo: {},
    recordings:[],
    decastRecordings: [],
    activePopup: '',
    recording: null,  
    videoUrl: null 
  };
};

export default getDefaultState;
